import React from 'react';

import SectionCode from '~/components/SectionCode.react';
import SectionDescription from '~/components/SectionDescription.react';
import SectionExample from '~/components/SectionExample.react';
import SectionTitle from '~/components/SectionTitle.react';
import InlineCode from '~/components/InlineCode.react';
import PopoverBottomAligned from '~/pages/components/popovers/PopoverBottomAligned.react';
import PopoverLeftAligned from '~/pages/components/popovers/PopoverLeftAligned.react';
import PopoverRightAligned from '~/pages/components/popovers/PopoverRightAligned.react';
import PopoverTopAligned from '~/pages/components/popovers/PopoverTopAligned.react';

import { popoverAlignment } from '~/components/CodeSnippets.js';

export default function PopoverAlignment() {
    return (
        <section className="marginBottom-xl">
            <div className="marginBottom-m breakPointM-marginBottom-l">
                <SectionTitle sectionTitle={'Popover Alignment'} />

                <SectionDescription>
                    There are left and right alignment classes for smaller
                    popovers which need to be pinned to their parent elements.
                    Adding a class <InlineCode>
                        popover--leftAligned
                    </InlineCode>{' '}
                    or <InlineCode>popover--rightAligned</InlineCode> will
                    adjust the popover's positioning and transform origin
                    accordingly.
                </SectionDescription>
            </div>

            <SectionExample>
                <div className="grid grid--1 breakPointM-grid--2 breakPointL-grid--4">
                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointM-borderRightWidth-1 breakPointL-borderBottomWidth-0">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverLeftAligned />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">
                            Left Aligned Popover
                        </p>
                    </div>

                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointL-borderBottomWidth-0 breakPointL-borderRightWidth-1">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverRightAligned />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">
                            Right Aligned Popover
                        </p>
                    </div>

                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointM-borderBottomWidth-0 breakPointM-borderRightWidth-1">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverBottomAligned />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">
                            Bottom Aligned Popover
                        </p>
                    </div>

                    <div className="padding-m textAlign-center">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverTopAligned />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">
                            Top Aligned Popover
                        </p>
                    </div>
                </div>
            </SectionExample>

            <SectionCode codeType="language-html" code={popoverAlignment} />
        </section>
    );
}



/** WEBPACK FOOTER **
 ** ./src/site/js/pages/components/popovers/PopoverAlignment.react.js
 **/